// TODO. 향 후 코드 개선
/* eslint-disable no-plusplus */
function numberToKorean(number: number) {
  const inputNumber = number < 0 ? false : number;
  const unitWords = ['', '만', '억', '조', '경'];
  const splitUnit = 10000;
  const splitCount = unitWords.length;
  const resultArray = [];

  let resultString = '';

  if (!inputNumber) {
    return resultString;
  }

  for (let i = 0; i < splitCount; i++) {
    let unitResult =
      // eslint-disable-next-line no-restricted-properties
      (inputNumber % splitUnit ** (i + 1)) / splitUnit ** i;
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult.toLocaleString();
    }
  }

  for (let i = 0; i < resultArray.length; i++) {
    // eslint-disable-next-line no-continue
    if (!resultArray[i]) continue;
    resultString = String(resultArray[i]) + unitWords[i] + resultString;
  }

  return resultString;
}

export default numberToKorean;
